module.exports = __webpack_public_path__ + "b2b5ae0f2ccaf776a2c7e499161cef8c.svg";